import { appConstants } from "../_constants";
import { appHelpers } from "../_helpers";

export const walletServices = {
  fetchWallet,
  fetchWalletHistory,
  getWalletFundingDetails,
  getWalletTransactionTypes,
  downloadWalletTransaction,
};

function fetchWallet(payload) {
  return appHelpers
    .postRequest(`${appConstants.PAS_URL}/api/Wallet/SummaryBDA`, payload)
    .then((res) => {
      const { error } = res.response;
      if (!error) {
        return res;
      } else {
        return appHelpers.formatPromiseResponse(
          error,
          appConstants.ERROR_RESPONSE
        );
      }
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function fetchWalletHistory(payload) {
  const { walletNumber, ...restPayload } = payload;
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/Wallet/GetWalletDetailsBDA?walletNumber=${walletNumber}`,
      restPayload
    )
    .then((res) => {
      const { error } = res.response;
      if (!error) {
        return res;
      } else {
        return appHelpers.formatPromiseResponse(
          error,
          appConstants.ERROR_RESPONSE
        );
      }
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getWalletFundingDetails(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/Wallet/GetWalletFundingDetailsBDA?walletNumber=${payload.walletNumber}&agencyId=${payload.agencyId}`
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function getWalletTransactionTypes() {
  return appHelpers
    .getRequest(`${appConstants.PAS_URL}/api/Wallet/WalletTransactionTypeBDA`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

function downloadWalletTransaction(payload) {
  const { walletNumber, ...restPayload } = payload;
  return appHelpers.postRequest(`${appConstants.PAS_URL}/api/Wallet/SearchDownloadBDA?walletNumber=${walletNumber}`,
      restPayload
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// /api/Wallet/GetWalletFundingDetails
